import React, {Component} from 'react';
import {Map, GoogleApiWrapper, InfoWindow, Marker} from 'google-maps-react';
import "../styles/map.css"
import "../styles/contactus.css"


const darkStyle = [
    {elementType: 'geometry', stylers: [{color: '#222120'}]},
    {elementType: 'labels.text.stroke', stylers: [{color: '#222120'}]},
    {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
    {
        featureType: 'administrative.locality',
        elementType: 'labels.text.fill',
        stylers: [{color: '#A86550'}]
    },
    {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{color: '#A86550'}]
    },
    {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{color: '#263c3f'}]
    },
    {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{color: '#6b9a76'}]
    },
    {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{color: '#38414e'}]
    },
    {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [{color: '#212a37'}]
    },
    {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [{color: '#9ca5b3'}]
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{color: '#746855'}]
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{color: '#1f2835'}]
    },
    {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{color: '#f3d19c'}]
    },
    {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [{color: '#2f3948'}]
    },
    {
        featureType: 'transit.station',
        elementType: 'labels.text.fill',
        stylers: [{color: '#d59563'}]
    },
    {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{color: '#17263c'}]
    },
    {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{color: '#515c6d'}]
    },
    {
        featureType: 'water',
        elementType: 'labels.text.stroke',
        stylers: [{color: '#17263c'}]
    }
]


export class MapContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showingInfoWindow: false,  //Hides or the shows the infoWindow
            activeMarker: {},          //Shows the active marker upon click
            selectedPlace: {name: 'CA Siddharth S. Dwivedi & Co.'},         //Shows the infoWindow to the selected place upon a marker
            mapLoaded: false
        };
        this.onMarkerClick = this.onMarkerClick.bind(this);
        this.onClose = this.onClose.bind(this);
        this.getButton = this.getButton.bind(this);
        this.handleMapIdle = this.handleMapIdle.bind(this);
        this.onMarkerMounted = this.onMarkerMounted.bind(this);
    }

    handleMapIdle = () => {
        this.setState({
            mapLoaded: true
        });
    }

    onMarkerClick = (props, marker, e) =>
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true

        });

    onClose = props => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null
            });
        }
    };

    getButton = () => {
        return <a href="www.google.com">click here</a>
    };

    onMarkerMounted = element => this.onMarkerClick(element.props, element.marker, element);


    render() {
        let selectedPlace = {name: 'CA Siddharth S. Dwivedi & Co.'}

        return (
            <Map
                className="map"
                google={this.props.google}
                zoom={14}
                onIdle={this.handleMapIdle}
                styles={darkStyle}
                containerStyle={{
                    height: '350px', width: '100%', position: 'relative',
                    paddingLeft: '70px', paddingRight: '70px'
                }}
                initialCenter={{lat: 19.2900249, lng: 72.8630187}}>

                {this.state.mapLoaded && (
                    <Marker ref={this.onMarkerMounted} onClick={this.onMarkerClick}
                            name={'CA Siddharth S. Dwivedi & Co.'}/>
                )}

                <InfoWindow
                    marker={this.state.activeMarker}
                    visible={this.state.showingInfoWindow}
                    onClose={this.onClose}>
                    <div style={{color: "black", height: '60px'}}>
                        <h6>{selectedPlace.name}</h6>
                        <p></p>
                        <p></p>
                        <a href="http://maps.google.com/maps?daddr=19.2900249,72.8630187" target="_blank"
                           className="button-my">Get Directions</a>

                    </div>
                </InfoWindow>
            </Map>
        );
    }
}

export default GoogleApiWrapper({
    apiKey: process.env.REACT_APP_KEY
})(MapContainer);